import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "bayked_exclusive_deals/";
const getBranchExclusiveDeals = (branchId) => axios.get(baseURL + "get_branch_exclusive_deals/" + branchId);
const addUpdateBranchExclusiveDeal = (baykedExclusiveDealObj) => axios.post( baseURL + "add_update_branch_exclusive_deal", baykedExclusiveDealObj);
const getBaykedDealDetailsById = (deal_id) => axios.get( baseURL + "get_bayked_exclusive_deal_detail/" + deal_id);
const getDealServings = (dealId) => axios.get( baseURL + "get_servings_of_menu_item/" + dealId)
const getBranchTiming = (branchId) => axios.get( baseURL + "populate_deals_timing_from_branch_timing/" + branchId)

export {
    getBranchExclusiveDeals,
    addUpdateBranchExclusiveDeal,
    getBaykedDealDetailsById,
    getDealServings,
    getBranchTiming
}